declare global {
  interface Window {
    originalMatchMedia?: (query: string) => MediaQueryList;
  }
}

const matchMediaPolyfill = (query: string): MediaQueryList => {
  const mql = window.originalMatchMedia
    ? window.originalMatchMedia(query)
    : window.matchMedia(query);

  // ✅ Safari 12 compatibility fix
  if (!mql.addEventListener) {
    mql.addEventListener = function (
      _type: string,
      listener: EventListenerOrEventListenerObject
    ) {
      // @ts-ignore
      mql.addListener(listener);
    };
    mql.removeEventListener = function (
      _type: string,
      listener: EventListenerOrEventListenerObject
    ) {
      // @ts-ignore
      mql.removeListener(listener);
    };
  }

  return mql;
};

if (!window.originalMatchMedia) {
  window.originalMatchMedia = window.matchMedia;
}

window.matchMedia = matchMediaPolyfill;
